import { call, put, select, takeLatest } from 'redux-saga/effects'
import { reset } from 'redux-form'
import { getAuth } from '../../selectors/access/auth'
import getEntitiesByTypeByParent from '../../services/entity/getEntitiesByTypeByParent'
import { showLoader, hideLoader } from '../../actions/common'
import messageModalActions from '../../actions/modals/messageModal'
import { fetchCombosSuccess } from '../../actions/combos/combos'
import combosActionTypes from '../../constants/actions/combos/combos'
import { handleError } from '../errors/errorManager'

export function * fetchEntitiesByTypeByParent ({ entityTypeId, parentId }) {
  try {
    yield put(showLoader())
    const auth = yield select(getAuth)
    const childEntityCombo = yield call(getEntitiesByTypeByParent, entityTypeId, parentId, auth.token)
    yield put(fetchCombosSuccess({ childEntityCombo }))
  } catch (error) {
    const customHandler = function * () {
      yield put(messageModalActions.openErrorMessageModal('MESSAGES.FETCH_COMBO_ERROR'))
    }
    const sessionHandler = function * () {
      yield put(reset('salesDossier'))
      yield put(reset('purchase_dossier'))
      yield put(reset('paperwork_dossier'))
      yield put(reset('campaign_dossier'))
    }
    yield call(handleError, { error, customHandler, sessionHandler })
  } finally {
    yield put(hideLoader())
  }
}

export function * watchFetchEntitiesByTypeByParent () {
  yield takeLatest(combosActionTypes.FETCH_ENTITIES_BY_TYPE_BY_PARENT, fetchEntitiesByTypeByParent)
}
